import { useMemo, useState } from "react";

import { ChartTypeSettings } from "../../../../analytics/AnalyticsInDetailPage/chart-options";
import { ChartType } from "../../../../analytics/AnalyticsOverTimePage/ChartActions";

export default function useChartTypeSettings(defaultValue: ChartType) {
  const [chartType, setChartType] = useState(defaultValue);
  return useMemo<ChartTypeSettings>(() => ({ chartType, setChartType }), [chartType]);
}
